/**
 * Asynchronously loads the component for TestDACIContactPopup
 */

import { lazyLoad } from 'utils/loadable';

export const TestDACIContactPopup = lazyLoad(
  () => import('./index'),
  module => module.default
);
